import React,{ PureComponent} from 'react';
import './List.scss';
import ListItem from '../list-item/ListItem';
import immutable from 'immutable';

export default class List extends PureComponent {
	constructor(props) {
		super(props);
	}
	shouldComponentUpdate(nextProps) {
		return !(nextProps.aData === this.props.aData || immutable.is(nextProps.aData, this.props.aData));
	}

    render() {
        return (
	        <ul className={"m-index-list " + (this.props.yanzhi ? "" : "landscape-list")}>
		        {this.props.aData.map((value, index) =>
			        <ListItem oData={value} key={index} index={index+1}  search={this.props.search} isYanzhi={this.props.yanzhi}/>
		        )}
	        </ul>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/index/list/List.jsx